import React from 'react';
import { Button } from '@/components/ui/button';

export default class RouteErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: props.forceError || null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.forceError && props.forceError !== state.error) {
            return { error: props.forceError };
        }
        return null;
    }

    componentDidCatch(error, info) {
        console.error('[RouteErrorBoundary]', error, info?.componentStack);
        import('../observability/sentry.js').then(({ captureException }) => {
            captureException(error, { componentStack: info?.componentStack });
        }).catch(() => {});
        if (typeof this.props.onError === 'function') {
            this.props.onError(error, info);
        }
    }

    handleRetry = () => {
        this.setState({ error: null });
        if (typeof this.props.onRetry === 'function') {
            this.props.onRetry();
        } else if (this.props.forceError) {
            window.location.assign('/deals');
        }
    };

    render() {
        if (this.state.error) {
            return (
                <div className="crm-page flex flex-col items-center justify-center gap-3 p-8 text-center min-h-[240px]">
                    <h2 className="text-base font-semibold text-foreground m-0">Something went wrong</h2>
                    <p className="text-sm text-muted-foreground m-0 max-w-md">
                        This page failed to load. You can retry or continue using the rest of the app.
                    </p>
                    <Button type="button" variant="secondary" size="sm" onClick={this.handleRetry}>
                        Retry
                    </Button>
                </div>
            );
        }
        return this.props.children ?? null;
    }
}
